<template>
  <div>
    <b-navbar type="primary" variant="primary">
      <b-navbar-brand>
        <router-link to="/search">
          <b-img
            alt="Fairmat"
            class="logo-image"
            :src="require('../../assets/FairmatLogoWhite.png')"
          ></b-img>
        </router-link>
      </b-navbar-brand>

      <template v-if="isAuth && Object.keys(permissions).length > 0">
        <b-navbar-nav class="ml-auto nav-main--margin">
          <main-nav-bar
            :permissions="permissions"
            @open-sidebar="openSidebar"
            @open-sidebar-ai="openSidebarAi"
            @on-close-open-panels="closeOpenPanels"
          ></main-nav-bar>
        </b-navbar-nav>
        <b-navbar-nav class="nav-right">
          <user-bar @on-close-open-panels="closeOpenPanels"></user-bar>
          <languages-bar @on-close-open-panels="closeOpenPanels"></languages-bar>
        </b-navbar-nav>
      </template>
    </b-navbar>

    <sidebar :visible.sync="isSidebarOpen" :title="title" :subtitleAvailable="subtitleAvailable" :subtitle="subtitle">
      <template #content>
        <!-- NB: v-if prevent rendering iframe without src set -->
        <sidebar-content v-if="initialPath" :initialPath="initialPath" />
      </template>
    </sidebar>

    <!-- AI Sidebar -->
    <ai-sidebar :visible.sync="isAiSidebarOpen" />

  </div>
</template>

<script>
import Sidebar from '../Lib/Sidebar.vue'
import MainNavBar from './Navigation/MainNavBar.vue'
import LanguagesBar from './Navigation/LanguagesBar.vue'
import UserBar from './Navigation/UserBar.vue'
import SidebarContent from '../Lib/SidebarContent.vue'
import AiSidebar from '../AiAssistant/AiSidebar.vue'

export default {
  name: 'CustomNavbar',
  components: {
    Sidebar,
    MainNavBar,
    LanguagesBar,
    SidebarContent,
    UserBar,
    AiSidebar
  },
  data() {
    return {
      isSidebarOpen: false,
      title: null,
      subtitleAvailable: false,
      subtitle: null,
      initialPath: null,
      isAiSidebarOpen: false,
    }
  },
  computed: {
    permissions: {
      get() {
        return this.$store.getters.getPermissions.userPermissions || {}
      },
    },
  },
  methods: {
    convertDriversInList(list) {
      Object.values(list).forEach((element) => {
        element.drivers = element.drivers.toString()
      })
    },
    openSidebar(section) {
      this.getTitle(section)
      this.isSubtitleAvailable(section)
      this.getInitialPath(section)
      this.isSidebarOpen = !this.isSidebarOpen
    },
    openSidebarAi() {
      this.isAiSidebarOpen = !this.isAiSidebarOpen
    },
    getTitle(section) {
      if (section == 'download') {
        this.title = this.$t('navbar.download')
      } else {
        this.title = this.$t('navbar.releaseNotes')
      }
    },
    isSubtitleAvailable(section) {
      if (section == 'download') {
        this.subtitleAvailable = false
      }
      this.subtitleAvailable = true
    },
    getInitialPath(section) {
      const lang = this.$i18n.locale ? this.$i18n.locale : 'en'

      if (section == 'download') {
        this.initialPath = `documentation/${lang}/download/index.html`
      } else {
        this.initialPath = `documentation/${lang}/release-notes/index.html`
      }
    },
    closeOpenPanels() {
      // Close any open popovers to avoid conflicts
      this.$root.$emit('bv::hide::popover')
    },
    openAiSidebar() {
      this.isAiSidebarOpen = !this.isAiSidebarOpen
    },
  },
}
</script>

<style lang="scss" scoped>
// Everything stays on ONE line. The middle nav (main) is the flexible part; the right nav
// (user/languages) must never be pushed off, so it doesn't shrink.
.navbar {
  padding: 0rem 0rem 0rem 1rem !important;
  line-height: 1;
  height: var(--headerHeight);
  flex-wrap: nowrap;
  // Stop shrinking below 380px — narrower than this the bar keeps its layout and the page scrolls
  // horizontally instead of cramming/overlapping the controls.
  min-width: 380px;
}

.nav-main--margin {
  margin-right: 0.75rem;
  min-width: 0; // allow the main nav to shrink instead of forcing a wrap
}

.nav-right {
  height: var(--headerHeight);
  padding: 0.5rem 1rem 0.5rem 1rem;
  background-color: #e2491e;
  flex-shrink: 0; // keep language + user always visible
}

ul {
  align-items: center;
}

.logo-image {
  height: 30px;
  overflow: hidden;
  margin-top: 5px;
  margin-right: 24px;
}

/deep/ .sectionLink--margin * {
  margin-right: 0;
}

/deep/ .sectionLink a,
/deep/ .sectionLink--margin a {
  align-items: center;
  font-size: 0.8rem;
}
</style>
